import { Component, OnInit, Input } from '@angular/core';
import { ReportMetadata, ReportYear } from '../models/report.model';
// import {ButtonModule} from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { Observable } from 'rxjs/Observable';
import { NgForm } from '@angular/forms';
import { AuthUserService } from '../services/appInitialization/authUser.service';
import { LookupService } from '../services/lookups/lookup.service';
import { RequiredreportscheduleService } from '../services/requiredreportschedule.service';
import { SelectItem } from 'primeng/components/common/selectitem';

@Component({
  selector: 'app-requiredreportschedule',
  templateUrl: './requiredreportschedule.component.html',
  styleUrls: ['./requiredreportschedule.component.css']
})
export class RequiredreportscheduleComponent implements OnInit {
  // displayMetadata =false;
  reportScheduleData: ReportMetadata[];
  reportMetadata: ReportMetadata;
  saveReportMetadatafields: any;

  ReportYears: ReportYear[];
  cols: any[];

  reportCategory: SelectItem[];
  reportName: SelectItem[];
  fasPost: SelectItem[];
  country: SelectItem[];
  programArea: SelectItem[];
  reportStatus: SelectItem[];
  dueDateFilter: SelectItem[];
  distributionTypes: SelectItem[];

  @Input()
  ReportYear: ReportYear;

  constructor(
    private requiredreportService: RequiredreportscheduleService,
    private authUserService: AuthUserService,
    private reportService: RequiredreportscheduleService,
    private lookupService: LookupService
  ) {}

  ngOnInit() {
    this.ReportYear = new ReportYear();
    var currentYear =new Date().getFullYear();

    var Years = new Array<ReportYear>();
    Years = [
      { id: 1, year: currentYear+1 },
      { id: 2, year: currentYear },
      { id: 3, year: currentYear - 1 },
      { id: 4, year: currentYear - 2 }
    ];
    this.ReportYears = Years;
    this.ReportYear.id =2;
    this.ReportYear.year = currentYear;
    this.LoadTable(this.ReportYear);
  }

  onYearSelected(val) {
    console.log(val.year);
    this.LoadTable(val);
  }

  LoadTable(year: ReportYear) {
    this.requiredreportService.getReportbasedonyear(year.year).subscribe((data: ReportMetadata[]) => {
     // console.log('REPORT SCHEDULE===================' + JSON.stringify(data));
      this.reportScheduleData = data;

      var reportCategoryType = new Array<string>();
      var reportNameType = new Array<string>();
      var postType = new Array<string>();
      var countryType = new Array<string>();
      var programAreaType = new Array<string>();
      var dueDateType = new Array<string>();
      var reportState = new Array<string>();
      var distType = new Array<string>();

      this.reportScheduleData.sort((a,b):number=>{
          if (a.category > b.category) return 1;
          if (a.category < b.category) return -1;
          return 0;
      });

      for (let i = 0; i < this.reportScheduleData.length; i++) {
        reportCategoryType.push(this.reportScheduleData[i].category);
        reportNameType.push(this.reportScheduleData[i].reportName);
        postType.push(this.reportScheduleData[i].fasPost);
        countryType.push(this.reportScheduleData[i].country);
        programAreaType.push(this.reportScheduleData[i].programArea);
        reportState.push(this.reportScheduleData[i].reportState);
        dueDateType.push(this.reportScheduleData[i].dueDate.toString());
        distType.push(this.reportScheduleData[i].reportType);
      }
      this.reportCategory = this.GetUniqueValues(reportCategoryType);
      this.reportName = this.GetUniqueValues(reportNameType);
      this.fasPost = this.GetUniqueValues(postType);
      this.country = this.GetUniqueValues(countryType);
      this.programArea = this.GetUniqueValues(programAreaType);
      this.reportStatus = this.GetUniqueValues(reportState);
      this.dueDateFilter = this.dateSort(dueDateType);
      this.distributionTypes = this.GetUniqueValues(distType);
      // this.lookupService.getReportYear().subscribe(
      //   (Years:ReportYear[]) =>{
      //   console.log(Years);
      //   this.ReportYears = Years;
      //   console.log(this.ReportYears);

      this.cols = [
        { field: 'category', header: 'Category' },
        { field: 'reportName', header: 'Report Name' },
        { field: 'country', header: 'Country' },
        { field: 'fasPost', header: 'FAS Post' },
        { field: 'programArea', header: 'Program Area' },
        { field: 'reportType', header: 'Distribution' },
        { field: 'reportState', header: 'Status' },
        { field: 'dueDate', header: 'Due Date' }
      ];
      // }
      // );
    });
  }

  dateSort(filterItem: any[]): SelectItem[]{
    var returnArray = new Array<SelectItem>();
      for (let i = 0; i < filterItem.length; i++) {
        if (returnArray.filter(r => r.label == filterItem[i]).length == 0)
          returnArray.push({ label: filterItem[i], value: filterItem[i] });
      }
      returnArray.sort((a, b) => new Date(b.value).getTime() - new Date(a.value).getTime());
      return returnArray;
  }

  GetUniqueValues(vals: any[]): SelectItem[] {
    var returnArry = new Array<SelectItem>();
    for (let cnt = 0; cnt < vals.length; cnt++) {
      if (returnArry.filter(r => r.label == vals[cnt]).length == 0)
        returnArry.push({ label: vals[cnt], value: vals[cnt] });
    }
    //console.log(returnArry.length);
    returnArry.sort((a,b):number=>{
      if (a.value < b.value) return -1;
      if (a.value > b.value) return 1;
      return 0;
    });
    return returnArry;
  }
}



// WEBPACK FOOTER //
// ./src/app/requiredreportschedule/requiredreportschedule.component.ts